import ContactForm from "./ContactForm";

export default function Contact() {

    return (
        <>
            <section id="contact-section">
                <div className="contact-container">
                    <div className="contact-header">
                        <h2 className="section-title">HAVE A QUESTION ??</h2>
                    </div>

                    <div className="contact-content">
                        <div className="contact-info">
                            <div className="contact-info-header">
                                <h3 className="contact-subtitle">GET IN TOUCH</h3>
                            </div>

                            <div className="contact-description">
                                <p>Whether you're interested in enrolling in our courses, scheduling a trial lesson, or simply want to learn more about what we offer, our team is here to assist you. Please don't hesitate to contact us via phone, email, or by filling out the form.</p>
                            </div>

                            <div className="contact-details">
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </div>
                                    <div className="contact-text">
                                        <span><a href="tel:+91 8769373591">+91 8769373591</a></span>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </div>
                                    <div className="contact-text">
                                        <span><a href="tel:+91 8769073591">+91 8769073591</a></span>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </div>
                                    <div className="contact-text">
                                        <span className="email-label">FOUNDER'S EMAIL:</span>
                                        <span><a href="mailto:harshitarewadia@gmail.com">harshitarewadia@gmail.com</a></span>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </div>
                                    <div className="contact-text">
                                        <span><a href="mailto:harshitaschoolofmusic@gmail.com">harshitaschoolofmusic@gmail.com</a></span>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12,6 12,12 16,14" />
                                        </svg>
                                    </div>
                                    <div className="contact-text">
                                        <div className="hours-info">
                                            <span>Monday to Friday: 8:00 am IST - 8:00 pm IST</span>
                                            <span>Saturday: 10:00 am IST - 7:00 pm IST</span>
                                            <span>Sunday: 12:00 am IST - 5:00 pm IST</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ContactForm />
                    </div>
                </div>
            </section>
        </>
    );
}